// import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { App } from "./containers/App";
import configureStore from "./store/store";

const MainApp = () => {
  const { store, persistor } = configureStore();

  // TO BE removed when fullcalendar adds a way to get rid of FontAwesome
  // FontAwesome injects css which is not allowed by CSP (require-trusted-types-for 'script')
  if (
    window.trustedTypes &&
    window.trustedTypes.createPolicy &&
    !window.trustedTypes.defaultPolicy
  ) {
    window.trustedTypes.createPolicy("default", {
      createHTML: (input) => input,
    });
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          {/* <ConnectedRouter history={history}> */}
          <Routes>
            <Route path="*" element={<App />} />
            {/* <Route path="/" element={<div>App</div>} /> */}
          </Routes>
          {/* </ConnectedRouter> */}
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default MainApp;
